import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';

export interface UploadedFile {
  fileName: string;
  uploadStatus: 'PENDING' | 'ERROR' | 'FAILED' | 'SUCCESS';
  validationErrorFilePath?: string;
  errorMessage?: string;
}

@Component({
  selector: 'app-uploaded-files',
  standalone: true,
  templateUrl: './uploaded-files.component.html',
  styleUrls: ['./uploaded-files.component.scss'],
  imports: [CommonModule],
})
export class UploadedFilesComponent {
  @Input() files: UploadedFile[] = [];
  @Output() downloadErrorReport = new EventEmitter<UploadedFile>();

  ngOnInit(): void {
    console.log(this.files);
  }

  onDownloadReport(file: UploadedFile): void {
    this.downloadErrorReport.emit(file);
  }
}
